import React from 'react';
import { AutocompleteInput, useRecordContext, useTranslate } from 'react-admin';


const InvoiceTypeInput = ({ source = 'invoice_type', ...props }) => {
	const record = useRecordContext(props);
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const choices = [
		{ id: 'credit', name: translate('Credit note') },
		{ id: 'invoice', name: translate('Invoice') }
	];

	return (
		<AutocompleteInput choices={choices} source={source} record={record} {...props} />
	);
};

export default InvoiceTypeInput;
